import {EventBus} from '@teemill/common/classes';

export const bus = new EventBus();
